import queryString from "query-string";
import { useParams } from "react-router-dom";
import React, { useEffect, useState } from "react";

import { Loader, Paper } from "../../components";
import Form from "./onboarding details components/Form";
import { useAxios, useComponent } from "../../hooks";
import {
  objectFromResponse,
  onboardingObject,
  setValue,
} from "./onboarding details components/onboardingObjects";
import DynamicFields from "./onboarding details components/FormTwo";

export default function DpOnBoardingDetails() {
  const axios = useAxios();
  const { loader } = useComponent();
  const { connectionID } = useParams();
  const brandID = queryString.parse(window.location.search).brandID;

  const [brands, setBrands] = useState([]);
  const [fields, setFields] = useState([]);
  const [editState, setEditState] = useState(true);
  const [additionalFields, setAdditionalFields] = useState([]);
  const [formData, setFormData] = useState(onboardingObject);
  const [fieldValue, setFieldValue] = useState({ fields: [] });
  const [PlatformTenantList, setPlatformTenantList] = useState([]);

  useEffect(() => {
    if (connectionID) {
      setEditState(false);
    }

    loader.start(3);

    axios({
      url: "/user/getOnboardingFields",
    }).then((field) => {
      let fielMap = [];
      if (field.status) {
        setFields(field.data);
        if (connectionID) {
          axios({
            url: "/user/getOnboardBrandMappedDetails?brandId=" + brandID,
          }).then((response) => {
            if (response.status) {
              if (response.data[0].connectionDetails.type_method === "NODE") {
                axios({
                  url: "/user/testConnectionDetails",
                  method: "POST",
                  data: {
                    connection_url:
                      response.data[0].connectionDetails.connection_url,
                    port: response.data[0].connectionDetails.port,
                    token: response.data[0].connectionDetails.token,
                  },
                  disableRedirect: true,
                }).then((res) => {
                  if (res.status) {
                    setAdditionalFields(res.data[2]?.additional_fields_columns);
                  }
                });
              }

              setFormData(objectFromResponse(response.data[0], field.data));
              setFieldValue(setValue(response.data[0], field.data));
              loader.apiComplete();
            }
          });
        } else {
          for (let f of field.data) {
            fielMap.push({
              [f.field_name]: {
                value: "",
                type: "",
                value_type: "",
                priority: [],
                org_trust: "",
                cpm_price: "",
                field_additional_info: "",
              },
            });
          }
          setFormData((prev) => ({
            ...prev,
            fields: fielMap,
          }));
          loader.apiComplete();
        }
        loader.apiComplete();
      }
    });

    axios({
      url: "/list/dynamicDashboard",
      disableRedirect: true,
    }).then((res) => {
      if (res.status) {
        setPlatformTenantList(res.data);
      }
    });

    axios({
      url: "/getAllOnboardingBrands",
    }).then((response) => {
      if (response.status) {
        setBrands(response.data);
        loader.apiComplete();
      } else {
        loader.stop();
      }
    });
  }, [axios, loader, connectionID, brandID]);

  return (
    <Loader>
      <Form
        PlatformTenantList={PlatformTenantList}
        additionalFields={additionalFields}
        fieldValue={fieldValue}
        fields={fields}
        brands={brands}
        formData={formData}
        setFormData={setFormData}
        editState={editState}
        setEditState={setEditState}
      />

      {fields.length > 0 && connectionID && (
        <Paper gridSpacing={6}>
          <DynamicFields
            formData={formData}
            setEditState={setEditState}
            setFieldValue={setFieldValue}
            fieldValue={fieldValue}
            fields={fields}
            editState={editState}
          />
        </Paper>
      )}
    </Loader>
  );
}
